import Vue from 'vue'
import moment from 'moment-timezone'
import App from './App.vue'
import router from './router'
import store from './store'

import vuetify from './plugins/vuetify'
import filters from './filters'
import './plugins'

import VuePerfectScrollbar from 'vue-perfect-scrollbar'

import '@/plugins/apexChart.js'

import '@/assets/scss/styles.scss'
import 'vue-navigation-bar/dist/vue-navigation-bar.css'
import VueNavigationBar from 'vue-navigation-bar'

import axios from 'axios'
import VueAxios from 'vue-axios'

import VueMeta from 'vue-meta'

Vue.use(VueMeta)
Vue.use(VueAxios, axios)
Vue.component('vue-navigation-bar', VueNavigationBar)
Vue.component(
  'layout',
  () => import('@/layout/Index'),
)
Vue.component('VuePerfectScrollbar', VuePerfectScrollbar)
Vue.prototype.moment = moment

Vue.config.productionTip = false

filters()

new Vue({
  store,
  router,
  vuetify,
  render: h => h(App),
}).$mount('#app')
